var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BasePageTitle',{attrs:{"title":_vm.$t('booking.pendingApproval.pageTitle'),"subtitle":"Manage your incoming booking requests here"}}),_c('BookingPendingApprovalsContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }